export default __webpack_public_path__ + "static/media/photo--sm--136.7b1bbe71.jpg";